<template>
  <div class="app-page">
    <PageHeader type="back" :backFun="goBack">
      <template #remark>
        <calendar-outlined style="margin-right: 4px" />
        <span>{{ $t('user.Application Due Date') }}:{{ applicationPeriod[1] }}</span>
      </template>
    </PageHeader>
    <div class="application-page-container">
      <div v-show="applyNode == 'fill'">
        <div class="application-page-panel">
          <div class="search-form">
            <a-form layout="inline" :model="searchForm" @finish="handleFinish">
              <a-form-item :label="$t('user.Current Role') + ':'">
                <a-select ref="select" v-model:value="searchForm.agency" :placeholder="$t('user.Brand')" @change="agencyHandleChange">
                  <a-select-option v-for="agency in agencyOptions" :key="agency" :value="agency">
                    {{ agency }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select ref="select" v-model:value="searchForm.role" :placeholder="$t('user.Role')" @change="roleHandleChange">
                  <a-select-option v-for="role in roleOptions" :key="role" :value="role">
                    {{ role }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-select ref="select" v-model:value="searchForm.level" :placeholder="$t('user.Level')" @change="levelHandleChange">
                  <a-select-option v-for="level in levelOptions" :key="level.key" :value="level.key">
                    {{ level.value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
          <div style="font-weight: initial !important; font-size: 12px">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</div>
        </div>
        <div class="job-info">
          <div class="info-left">
            <div class="jinfo-theme" v-if="jobInfo.theme">
              <span>{{ $t('user.Theme') }}:</span>
              {{ jobInfo.theme }}
            </div>
            <div class="jinfo-header default" v-if="jobInfo.theme == null">
              <div class="jinfo-title">{{ $t('user.Job Qualifications') }}</div>
            </div>
            <template v-if="jobInfo.jobQualifications.length === 0">
              <div class="jinfo-content default">
                {{ $t('user.Please select your current role to see job qualification list.') }}
              </div>
            </template>
            <template v-else>
              <a-table class="record-table" :rowKey="(record) => record.id" :columns="columns" :data-source="jobInfo.jobQualifications" :pagination="false">
                <template v-slot:emptyText>
                  <Empty />
                </template>
                <template v-slot:headerCell="{ title, column }">
                  <template v-if="column.key === 'text'">
                    {{ $t('user.' + title) }}
                    <!-- <div style="font-weight: initial !important">
                      *The highlighted items show the key difference between
                      this level and one level down.
                    </div> -->
                  </template>
                  <template v-else-if="column.key === 'check'">
                    {{ $t('user.' + column.title) }}?
                    <a-tooltip>
                      <template #title>
                        {{ $t('user.Check the box if you meet the qualification.') }}
                      </template>
                      <question-circle-filled />
                    </a-tooltip>
                  </template>
                  <template v-else-if="column.key === 'comments'">
                    {{ $t('user.' + title) }}
                    <a-tooltip>
                      <template #title>
                        {{ $t('user.Please leave comments on the qualification boxes which are not checked.') }}
                      </template>
                      <question-circle-filled />
                    </a-tooltip>
                  </template>
                </template>

                <template v-slot:bodyCell="{ record, column }">
                  <template v-if="column.key === 'text'">
                    <div :style="`text-align:left;${record.style == 'high' ? 'color:#ac7f40' : ''}`">
                      {{ record.value }}
                    </div>
                  </template>
                  <template v-else-if="column.key === 'check'">
                    <div style="width: 100%; text-align: center">
                      <a-checkbox v-model:checked="record.check" @change="qualifiedHandleChange(record)"></a-checkbox>
                    </div>
                  </template>
                  <CommentsEditor v-else-if="column.key === 'comments'" v-model:text="record[column.key]" @autoSave="submitComment(record)" status="edit" />
                  <template v-else-if="column.key === 'content'">
                    <div style="text-align: left">{{ record.content }}</div>
                  </template>
                </template>
              </a-table>

              <div class="btn-submit-group">
                <!-- <a-button class="btn-save" @click="saveApply">Save</a-button> -->
                <a-popover trigger="click" placement="topLeft" v-if="hasUnfinished > 0">
                  <template #content>
                    <div class="popover-tips" v-if="isEn">
                      <exclamation-circle-filled />
                      <span v-if="hasUnfinished == 1">
                        Please leave comments on the
                        <span style="text-decoration: underline">job qualification</span>
                        boxes which are not checked.
                      </span>
                      <!-- <span v-if="hasUnfinished == 2">
                        Please leave comments if any of the
                        <span style="text-decoration: underline">
                          mandatory learning
                        </span>
                        record is not checked.
                      </span> -->

                      <span v-if="hasUnfinished == 2">You didn't complete all the mandatory courses of your current role and level as required. Please keep up your efforts, try to meet the prerequisite and apply next time. Thank you.</span>
                      <span v-if="hasUnfinished == 3">You didn't complete all the mandatory courses of your current role and level as required. Please keep up your efforts, try to meet the prerequisite and apply next time. Thank you.</span>

                      <!-- <span v-if="hasUnfinished == 3">
                        Please leave comments on the
                        <span style="text-decoration: underline">
                          job qualification
                        </span>
                        boxes and
                        <span style="text-decoration: underline">
                          mandatory learning
                        </span>
                        record if they are not all checked.
                      </span> -->
                    </div>
                    <!-- prettier-ignore -->
                    <div class="popover-tips" v-else>

                      <span v-if="hasUnfinished == 1">请在未勾选的<span style="text-decoration: underline">岗位要求</span>旁留下评语</span>
                      <!-- <span v-if="hasUnfinished == 2">您有<span style="text-decoration: underline">必修课程</span>未完成，请在下方说明原因</span> -->
                      <span v-if="hasUnfinished == 2">您未按要求完成当前角色职级的全部必修课程。请继续努力，争取在下一季满足必备条件、申请出狮，谢谢！</span>
                      <span v-if="hasUnfinished == 3">您未按要求完成当前角色职级的全部必修课程。请继续努力，争取在下一季满足必备条件、申请出狮，谢谢！</span>
                      <!-- <span v-if="hasUnfinished == 3">
                        如果<span style="text-decoration: underline">能力要求</span>和<span style="text-decoration: underline">必修课程</span>有未勾选的项目，请在相应区域留下自评或是说明原因
                      </span> -->
                    </div>
                  </template>

                  <a-button class="btn-next" type="primary">
                    {{ $t('user.Next') }}
                  </a-button>
                </a-popover>

                <a-button v-else class="btn-next" @click="submitNext" type="primary">
                  {{ $t('user.Next') }}
                </a-button>
              </div>
            </template>
          </div>
          <div class="info-right">
            <div class="jinfo-header">
              <div class="jinfo-title" v-if="jobInfo.jobQualifications.length === 0">
                {{ $t('user.Learning') }}
              </div>
              <div class="jinfo-title" v-else>
                {{ $t('user.Learning Record') }}
                <a-tooltip>
                  <template #title>
                    {{ $t('user.√ and × are marked based on the valid record of your training completion. If the mandatory courses and tests are not all completed (marked as ×), you would not be able to submit the application. If you have any question, please contact') }}
                    PG_China_Academy_PUB_CN@publicisgroupe.net
                  </template>
                  <QuestionCircleFilled class="question-circle" />
                </a-tooltip>
              </div>
            </div>
            <template v-if="jobInfo.jobQualifications.length === 0">
              <div class="jinfo-content default">
                {{ $t('user.Please select role to see learning resources.') }}
              </div>
            </template>
            <div class="jinfo-sub-header" v-if="docs.length > 0">
              <div class="jinfo-title">{{ $t('user.Mandatory') }}</div>
            </div>
            <div v-for="(doc, index) in docs" :key="index" class="jinfo-content">
              <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
              <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
              <span
                :class="{
                  doc: true,
                  'doc-highlight': doc.type == 'doc_highlight',
                }"
              >
                {{ doc.f }}
              </span>
            </div>
            <div class="jinfo-sub-header" v-if="docs_optional.length > 0">
              <div class="jinfo-title">{{ $t('user.Optional') }}</div>
            </div>
            <div v-for="(doc, index) in docs_optional" :key="index" class="jinfo-content">
              <CheckOutlined style="color: #ac7f40; font-size: 18px" v-if="doc.checked" />
              <CloseOutlined style="color: #f44336; font-size: 18px" v-else />
              <span
                :class="{
                  doc: true,
                  'doc-highlight': doc.type == 'doc_highlight',
                }"
              >
                {{ doc.f }}
              </span>
            </div>
            <div class="jinfo-footer" v-if="jobInfo.jobQualifications.length != 0">
              <CommentsEditor @autoSave="submitRightComment" v-model:text="comment" status="edit" />
            </div>
          </div>
        </div>
      </div>
      <div v-show="applyNode === 'select'">
        <div class="application-page-panel">
          <div class="search-form">
            <a-timeline>
              <a-timeline-item>
                <label class="current-role-label">
                  {{ $t('user.Current Role') }}
                </label>
                <span class="current-role-value">
                  {{ jobInfo.agency }} - {{ jobInfo.role }} -
                  {{ jobInfo.level }}
                </span>
              </a-timeline-item>
              <a-timeline-item>
                <a-form layout="inline" :model="targetSearchForm" @finish="handleTargetFinish">
                  <div class="flex">
                    <a-form-item class="item-label-target" :label="$t('user.Target Role')">
                      <a-select ref="select" v-model:value="targetSearchForm.agency" :placeholder="$t('user.Brand')" @change="targetAgencyHandleChange">
                        <a-select-option v-for="agency in agencyOptions" :key="agency" :value="agency">
                          {{ agency }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item>
                      <a-select ref="select" v-model:value="targetSearchForm.role" :placeholder="$t('user.Role')" @change="targetRoleHandleChange">
                        <a-select-option v-for="role in targetRoleOptions" :key="role" :value="role">
                          {{ role }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item>
                      <a-select ref="select" v-model:value="targetSearchForm.level" :placeholder="$t('user.Level')" @change="targetLevelHandleChange" class="level-select">
                        <a-select-option v-for="level in targetLevelOptions" :key="level.key" :value="level.key">
                          {{ level.value }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </a-form>
              </a-timeline-item>
            </a-timeline>
          </div>
          <div style="font-weight: initial !important; font-size: 12px">*{{ $t('user.The highlighted items show the key difference between this level and one level down.') }}</div>
        </div>

        <div class="target-job-info">
          <div class="info-left">
            <div class="jinfo-theme" v-if="targetInfo.theme">
              <span>{{ $t('user.Theme') }}:</span>
              {{ targetInfo.theme }}
            </div>
            <div :class="`jinfo-header ${targetInfo.theme != null ? 'msg' : 'default'}`">
              <div class="jinfo-title">
                {{ $t('user.Job Qualifications') }}
                <!-- <span style="font-weight: initial; margin-left: 8px">
                  *The highlighted items show the key difference between this
                  level and one level down.
                </span> -->
              </div>
            </div>
            <template v-if="targetInfo.jobQualifications.length === 0">
              <div class="jinfo-content default">
                {{ $t('user.Please select your target role to see job qualification list') }}
              </div>
            </template>
            <template v-else>
              <ul class="qualification-list">
                <li v-for="qua in targetInfo.jobQualifications" :class="qua.style" :key="qua.key">
                  {{ qua.value }}
                </li>
              </ul>
              <div class="btn-submit-group" v-if="targetInfo.id != null">
                <a-button class="btn-save" @click="goBack">
                  {{ $t('user.Back') }}
                </a-button>
                <a-button class="btn-next" @click="submitGApply" type="primary">
                  {{ $t('user.Submit') }}
                </a-button>
              </div>
            </template>
          </div>
          <div class="info-right">
            <div class="jinfo-header">
              <div class="jinfo-title">{{ $t('user.Learning') }}</div>
            </div>
            <template v-if="targetInfo.jobQualifications.length === 0">
              <div class="jinfo-content default">
                {{ $t('user.Please select your target role to see learning resources.') }}
              </div>
            </template>
            <div class="jinfo-sub-header" v-if="target_docs.length > 0">
              <div class="jinfo-title">{{ $t('user.Mandatory') }}</div>
            </div>
            <div v-for="(doc, index) in target_docs" :key="index" class="jinfo-content">
              <span
                :class="{
                  'doc-highlight': doc.type == 'doc_highlight',
                }"
              >
                {{ doc.f }}
              </span>
            </div>
            <div class="jinfo-sub-header" v-if="target_docs_optional.length > 0">
              <div class="jinfo-title">{{ $t('user.Optional') }}</div>
            </div>
            <div v-for="(doc, index) in target_docs_optional" :key="index" class="jinfo-content">
              <span
                :class="{
                  'doc-highlight': doc.type == 'doc_highlight',
                }"
              >
                {{ doc.f }}
              </span>
            </div>
            <!-- <div class="jinfo-footer">
              <CommentsEditor v-model:text="comment" status="edit" />
            </div> -->
          </div>
        </div>
      </div>
      <div v-if="applyNode === 'success'" class="success-panel">
        <svg-icon icon-class="success"></svg-icon>
        <div class="message">{{ $t('user.Submitted Successfully') }}</div>
        <div class="tips">
          {{ username }},
          {{ $t('user.your application has been submitted successfully!') }}
        </div>
        <div class="tips">
          {{ $t('user.Please wait for response and feedback from your review manager.') }}
        </div>
        <div class="btn-group-success">
          <router-link :to="{ path: '/me/application' }">
            <a-button class="btn-view">
              {{ $t('user.View My Application') }}
            </a-button>
          </router-link>
          <router-link :to="{ path: '/index' }">
            <a-button class="btn-back" type="primary">
              {{ $t('user.Back to Home') }}
            </a-button>
          </router-link>
        </div>
      </div>
      <a-modal v-model:visible="commentVisible" title="Leave Comments" okText="Done" @ok="submitComment">
        <div class="comment-panel">
          <a-textarea v-model:value="commentDialogValue" placeholder="Please write your comments" :rows="5" />
        </div>
      </a-modal>
      <a-modal v-model:visible="overrideVisible" @cancel="resetQualified" @ok="submitOverride" :ok-text="$t('user.OK')" :cancel-text="$t('user.Cancel')">
        <p>
          {{ $t('user.your previous choice will be override, are you sure?') }}
        </p>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { Modal, message } from 'ant-design-vue'
  import { QuestionCircleFilled, FormOutlined, CalendarOutlined, ExclamationCircleFilled, CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'
  import { getAgencyOptions, getRoleOptions, getLevelOptions, getTargetLevelOptions } from '@/api/dict'
  import CommentsEditor from '@/components/CommentsEditor'
  import PageHeader from '@/components/PageHeader.vue'
  import { getJobQualifications, getApplyRetrieve, saveSelfEvaluation, saveTarget, submitApply, saveCurrentTmp } from '@/api/index'
  import avators from '@/assets/avator'
  import i18n from '@/locales'
  import Empty from '@/components/Empty'

  export default {
    name: 'Index',
    components: {
      QuestionCircleFilled,
      CalendarOutlined,
      CommentsEditor,
      PageHeader,
      ExclamationCircleFilled,
      CheckOutlined,
      CloseOutlined,
      Empty,
    },
    data() {
      return {
        hasChanged: false,
        commentsViewPopoverVisible: false,
        columns: [
          {
            title: 'Job Qualifications',
            width: 400,
            key: 'text',
            dataIndex: 'value',
          },
          {
            title: 'Qualified',
            width: 120,
            key: 'check',
            dataIndex: 'check',
          },
          {
            title: 'Comments',
            width: 120,
            key: 'comments',
            dataIndex: 'comments',
          },
        ],
        commentVisible: false,
        overrideVisible: false,
        commentDialogId: null,
        commentDialogValue: null,
        // applyNode: 'fill', //fill select success
        applyNode: '',
        searchForm: {
          agency: undefined,
          role: undefined,
          level: undefined,
        },
        targetSearchForm: {
          agency: undefined,
          role: undefined,
          level: undefined,
        },
        jobInfo: {
          agency: null,
          id: null,
          level: null,
          resources: null,
          theme: null,
          jobQualifications: [],
        },
        targetInfo: {
          agency: null,
          id: null,
          level: null,
          resources: null,
          theme: null,
          jobQualifications: [],
        },
        learningMsg: null,
        agencyOptions: [],
        roleOptions: [],
        levelOptions: [],
        targetRoleOptions: [],
        targetLevelOptions: [],
        isForce: false,
        currentRecord: null,
        comment: null,
      }
    },
    watch: {
      applyNode: {
        handler(data) {
          if (data == 'select') {
            this.$store.commit('routes/setSider', 'me/apply/target')
          } else if (data == 'fill') {
            this.$store.commit('routes/setSider', 'me/apply')
          } else if (data == 'success') {
            this.$store.commit('routes/setSider', 'user')
          }
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({
        username: 'user/username',
        applicationPeriod: 'user/applicationPeriod',
      }),
      hasUnfinished() {
        const unfinished = this.jobInfo.jobQualifications.find((item) => {
          return item.check != true && (item.comments == '' || item.comments == null)
        })

        const docs = this.docs.filter((doc) => {
          return !doc.checked
        })

        if (unfinished) {
          console.log('unfinished', unfinished)
        }

        return (
          (unfinished != null ? 1 : 0) +
          // (docs.length == 0 || (this.comment != null && this.comment != '')
          (docs.length == 0 ? 0 : 2)
        )
      },
      docs() {
        const records = this.jobInfo.records
        if (records) {
          return (
            this.jobInfo.docs
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.jobInfo.docs
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      docs_optional() {
        const records = this.jobInfo.records
        if (records) {
          return (
            this.jobInfo.docs_optional
              ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
              .map((el) => {
                el.checked = records.indexOf(el.f.toLowerCase()) != -1
                return el
              }) || []
          )
        }
        return (
          this.jobInfo.docs_optional
            ?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight')
            .map((el) => {
              el.checked = false
              return el
            }) || []
        )
      },
      target_docs() {
        const records = this.targetInfo.records
        if (records) {
          return this.targetInfo.docs?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight') || []
        }
        return this.targetInfo.docs?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight') || []
      },
      target_docs_optional() {
        const records = this.targetInfo.records
        if (records) {
          return this.targetInfo.docs_optional?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight') || []
        }
        return this.targetInfo.docs_optional?.filter((el) => el.type == 'doc' || el.type == 'doc_highlight') || []
      },
      isEn() {
        return i18n.global.locale == 'en-US'
      },
    },
    mounted() {
      getAgencyOptions().then((res) => {
        if (res.code == 200) {
          this.agencyOptions = res.data
        }
      })
      getApplyRetrieve()
        .then((res) => {
          if (res.code === 200) {
            const { current, target, is_submit, comment } = res.data
            if (is_submit) {
              this.applyNode = 'success'
            } else {
              this.applyNode = 'fill'
              this.searchForm.agency = current.agency
              this.searchForm.role = current.role
              this.searchForm.level = current.guide_id
              this.setSilderAvator(current.role)
              // 加载选项
              this.levelOptions = [{ key: current.guide_id, value: current.level }]
              getRoleOptions(this.searchForm.agency).then((res) => {
                if (res.code == 200) {
                  this.roleOptions = res.data
                }
              })
              getLevelOptions(this.searchForm.agency, this.searchForm.role).then((res) => {
                if (res.code == 200) {
                  this.levelOptions = res.data
                }
              })
              const hdata = current.items
              this.handleFinish().then(() => {
                this.setSilderAvator(this.searchForm.role)
                hdata.forEach((item) => {
                  const row = this.jobInfo.jobQualifications.find((jq) => jq.id === item.id)

                  if (row) {
                    row.check = item.check
                    row.comments = item.comments
                  }
                })
              })

              this.comment = comment

              if (target.level) {
                this.targetSearchForm.agency = target.agency
                this.targetSearchForm.role = target.role
                this.targetSearchForm.level = target.guide_id
                // 加载选项
                this.targetLevelOptions = [{ key: target.guide_id, value: target.level }]
                getRoleOptions(this.targetSearchForm.agency).then((res) => {
                  if (res.code == 200) {
                    this.targetRoleOptions = res.data
                  }
                })
                getTargetLevelOptions(this.targetSearchForm.agency, this.targetSearchForm.role).then((res) => {
                  if (res.code == 200) {
                    this.targetLevelOptions = res.data
                  }
                })
                this.handleTargetFinish()
              }
            }
          } else {
            this.applyNode = 'fill'
          }
        })
        .catch((err) => {
          this.applyNode = 'fill'
        })
    },
    methods: {
      goBack() {
        if (this.applyNode == 'select') {
          this.applyNode = 'fill'
        } else {
          this.$router.replace('/index')
          // this.$router.back()
        }
      },
      setSilderAvator(rolename) {
        if (rolename) {
          const filename = rolename.toLocaleLowerCase().replace(/\s*/g, '')
          this.$store.dispatch('user/setAvator', avators[filename])
        }
      },
      agencyHandleChange(value) {
        this.searchForm.role = null
        this.searchForm.level = null
        getRoleOptions(value).then((res) => {
          if (res.code == 200) {
            this.roleOptions = res.data
            this.jobInfo = {
              agency: null,
              id: null,
              level: null,
              resources: null,
              theme: null,
              jobQualifications: [],
            }
          }
        })
      },
      roleHandleChange(value) {
        this.searchForm.level = null
        getLevelOptions(this.searchForm.agency, value).then((res) => {
          if (res.code == 200) {
            this.levelOptions = res.data
            this.jobInfo = {
              agency: null,
              id: null,
              level: null,
              resources: null,
              theme: null,
              jobQualifications: [],
            }
          }
        })
      },
      levelHandleChange(value) {
        this.handleFinish().then(() => {})
      },
      targetAgencyHandleChange(value) {
        this.targetSearchForm.role = null
        this.targetSearchForm.level = null
        getRoleOptions(value).then((res) => {
          if (res.code == 200) {
            this.targetRoleOptions = res.data
            this.targetInfo = {
              agency: null,
              id: null,
              level: null,
              resources: null,
              theme: null,
              jobQualifications: [],
            }
          }
        })
      },
      targetRoleHandleChange(value) {
        this.targetSearchForm.level = null
        getTargetLevelOptions(this.targetSearchForm.agency, value).then((res) => {
          if (res.code == 200) {
            this.targetLevelOptions = res.data
            this.targetInfo = {
              agency: null,
              id: null,
              level: null,
              resources: null,
              theme: null,
              jobQualifications: [],
            }
          }
        })
      },
      targetLevelHandleChange() {
        this.handleTargetFinish().then(() => {})
      },
      // levelHandleChange(value) {
      //   // this.jobInfo.id = value
      //   console.log(`selected ${value}`)
      // },
      qualifiedHandleChange(record) {
        this.currentRecord = record
        const that = this
        const data = {
          is_forced: this.isForce,
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
          comment: this.comment,
        }
        saveCurrentTmp(data)
          .then((res) => {
            console.log('Data', res)
          })
          .catch((error) => {
            if (error.code == 300) {
              that.overrideVisible = true
            }
          })
      },
      handleFinish() {
        this.setSilderAvator(this.searchForm.role)
        // this.jobInfo.id = this.searchForm.level;
        return getJobQualifications(this.searchForm.level).then((res) => {
          if (res.code == 200) {
            this.jobInfo = res.data
            this.jobInfo.jobQualifications = res.data.items.map((item) => {
              return {
                id: item.key,
                value: item.value,
                style: item.style,
                check: false,
                comments: null,
              }
            })
          }
          return res
        })
      },
      handleTargetFinish() {
        this.setSilderAvator(this.targetSearchForm.role)
        return getJobQualifications(this.targetSearchForm.level).then((res) => {
          if (res.code == 200) {
            this.targetInfo = res.data
            this.targetInfo.jobQualifications = res.data.items.map((item, index) => {
              if (typeof item === 'string') {
                return {
                  id: index,
                  value: item,
                }
              } else {
                return {
                  id: item.key,
                  value: item.value,
                  style: item.style,
                  check: false,
                  comments: null,
                }
              }
            })
          }
          return res
        })
      },
      editComment(data) {
        this.commentDialogId = data.id
        this.commentDialogValue = data.comments
        this.commentVisible = true
      },
      submitComment(record) {
        // const current = this.jobInfo.jobQualifications.find(
        //   (item) => item.id === this.commentDialogId
        // )
        // current.comments = this.commentDialogValue
        // this.commentVisible = false
        this.currentRecord = record
        const that = this
        const data = {
          is_forced: this.isForce,
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
        }
        saveCurrentTmp(data)
          .then((res) => {
            console.log('Data', res)
          })
          .catch((error) => {
            if (error.code == 300) {
              that.overrideVisible = true
            }
          })
      },
      resetQualified() {
        if (this.currentRecord) {
          this.currentRecord.check = false
          this.currentRecord.comments = null
        }
      },
      submitOverride() {
        const that = this
        const data = {
          is_forced: true,
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
        }
        saveCurrentTmp(data)
          .then((res) => {
            if (res.code == 200) {
              that.isForce = false
              that.overrideVisible = false
            }
          })
          .catch((error) => {})
      },
      saveApply(showMsg = true) {
        const data = {
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
          comment: this.comment,
        }
        // console.log(data)
        return saveSelfEvaluation(data).then((res) => {
          if (showMsg) {
            Modal.info({
              icon: false,
              closable: true,
              title: 'Save Information',
              content: 'Your assessment has been saved',
            })
            // message.success('You application has been saved')
          }
        })
      },
      submitNext() {
        if (this.hasUnfinished == 0) {
          return this.saveApply(false).then(() => {
            this.applyNode = 'select'
            this.$store.commit('routes/setSider', 'me/apply/target')
          })
        }
      },
      saveGTarget() {
        saveTarget(this.targetInfo.id).then(() => {
          Modal.info({
            icon: false,
            closable: true,
            title: 'Save Information',
            content: 'Your assessment has been saved',
          })
        })
      },
      submitGApply() {
        const vm = this
        const guideId = this.targetInfo.id

        Modal.confirm({
          title: this.$t('user.Submit Information'),
          okText: this.$t('user.Yes'),
          cancelText: this.$t('user.No'),
          closable: true,
          content: this.$t('user.Are you sure you want to submit this application now?'),
          onOk() {
            return submitApply(guideId).then((res) => {
              if (res.code === 200) {
                vm.applyNode = 'success'
              } else if (res.code === 300601) {
                message.info('Completed submission.')
              }
            })
          },
          onCancel() {},
        })
      },
      submitRightComment() {
        // const that = this
        const data = {
          is_forced: this.isForce,
          guide_id: this.jobInfo.id,
          items: this.jobInfo.jobQualifications.map((item) => {
            return {
              id: item.id,
              check: item.check,
              comments: item.comments,
            }
          }),
          comment: this.comment,
        }
        saveCurrentTmp(data)
          .then((res) => {
            console.log('Data', res)
          })
          .catch((error) => {
            // if (error.code == 300) {
            // that.overrideVisible = true
            // }
            console.log(error)
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');
  .application-page-container {
    margin: @app-conetent-margin;
  }

  .application-page-panel {
    padding: 20px 24px;
    background-color: white;
    margin-bottom: 16px;
  }

  .search-form {
    display: flex;
    margin-bottom: 10px;
    .ant-select {
      width: 20vw;
    }
    .level-select {
      width: 33vw;
    }
    :deep {
      .ant-form-item-label {
        label {
          font-weight: 700;
        }
      }
    }

    label {
      font-weight: bold;
      font-size: 14px;
      &::after {
        content: ':';
        margin: 0 8px 0 2px;
        position: relative;
        top: -0.5px;
      }
    }
    .current-role {
      &-value {
        font-weight: 600;
        color: @primary-color;
      }
    }
  }
  .item-label-target {
    :deep {
      .ant-form-item-label > label {
        font-weight: bold;
      }
    }
  }
  .target-job-info,
  .job-info {
    display: flex;
    min-height: 530px;
    .info-left {
      background-color: white;
      flex-grow: 7;
      width: 70%;
      margin-right: 16px;
    }
    .info-right {
      background-color: white;
      flex-grow: 3;
      width: 30%;
      position: relative;
    }
    .jinfo-theme {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-weight: 700;
      padding: 16px 24px;
    }
    .qualification-list {
      list-style: none;
      padding-left: 40px;
      li {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 42px;
        font-weight: 400;
        &.high {
          color: @primary-color;
        }
      }
    }
    .jinfo-header {
      padding: 16px 24px;
      border-bottom: 1px solid #e9e9e9;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        // background-color: #d7c7c7;
        background-color: #f5f3ef;
      }
    }

    .jinfo-footer {
      padding: 16px 24px;
      position: absolute;
      bottom: 0;
    }

    .jinfo-sub-header {
      padding: 16px 24px;
      .jinfo-title {
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        font-weight: 700;
      }
      &.msg {
        margin: 0 24px;
        background-color: #fafafa;
      }
    }

    .jinfo-content {
      padding: 0px 24px;
      padding-bottom: 14px;
      white-space: pre-line;
      &.list {
        padding: 16px 24px;
      }
      &.default {
        padding: 14px 24px;
      }
      .doc {
        margin-left: 8px;
      }
      .doc-highlight {
        color: @primary-color;
      }
    }
  }
  .record-table {
    padding: 0 24px;
  }
  .btn-submit-group {
    padding: 24px;
    .btn-save {
      width: 90px;
      margin: 0 8px;
    }
    .btn-next {
      width: 90px;
      margin: 0 8px;
    }
  }
  .popover-tips {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    .anticon {
      color: #faba16;
    }
  }
  .success-panel {
    background-color: white;
    height: 495px;
    padding-top: 68px;
    text-align: center;
    .svg-icon {
      width: 72px;
      height: 72px;
      color: #43a047;
      margin-bottom: 27px;
    }
    .message {
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      font-weight: 400;
      margin: 6px auto;
    }
    .tips {
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 22px;
    }
    .btn-group-success {
      margin-top: 60px;
      display: flex;
      justify-content: center;
      .btn-view,
      .btn-back {
        margin: 0 8px;
      }
    }
  }
</style>
